import { FC, useEffect, useState } from 'react';

import { useMembers } from '@/features/vfo/hooks/useMembers';
import { ApiMessageResponse, useApi } from '@/shared/api';
import { getPersonFullName } from '@/shared/helpers/names';

import { Reply, ReplyContent as ReplyContentStyles, ReplyName, ReplyText } from './styled';

type ReplyContentProps = {
  messageId: string;
  messages: ApiMessageResponse[];
  onClick: () => void;
};

export const ReplyContent: FC<ReplyContentProps> = ({ messageId, messages, onClick }) => {
  const [messageData, setMessageData] = useState<ApiMessageResponse | null>(null);

  const { getByProfileId } = useMembers();
  const api = useApi();

  const fetchMessage = async () => {
    const res = await api.chatsMessageFindOne(messageId);
    if (res.data) {
      setMessageData(res.data);
    }
  };

  useEffect(() => {
    const find = messages.find((item) => item.id === messageId);
    if (find) {
      setMessageData(find);
    } else {
      fetchMessage();
    }
  }, []);

  if (!messageData) return null;

  const memberData = getByProfileId(messageData.profileId);

  if (!memberData) return null;

  return (
    <Reply style={{ marginBottom: 4 }} onClick={onClick}>
      <ReplyContentStyles>
        <ReplyName>{getPersonFullName(memberData, 'display')}</ReplyName>
        <ReplyText>{messageData.body}</ReplyText>
      </ReplyContentStyles>
    </Reply>
  );
};
